import { lazy, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Toaster } from '@/components/ui/toaster';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { FacebookProvider } from '@kazion/react-facebook-login';
import Logout from './components/Logout';
import { AuthProvider } from '@/contexts/AuthContext';
import { cleanupRecaptchaDom } from './utils/cleanupRecaptcha';

const Login = lazy(() => import('@/features/auth/pages/Login'));
const Impersonate = lazy(() => import('@/features/auth/pages/Impersonate'));
const SetPassword = lazy(() => import('@/features/auth/pages/SetPassword'));
const ForgotPassword = lazy(() => import('@/features/auth/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('@/features/auth/pages/ResetPassword'));

const AuthRoutes: React.FC = () => {
  useEffect(() => {
    return () => {
      cleanupRecaptchaDom();
    };
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY!} >
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID!}>
        <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_APP_ID!}>
          <Toaster />
          <AuthProvider>
            <Routes>
              <Route path="/logout" element={<Logout />} />
            </Routes>
          </AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/impersonate" element={<Impersonate />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        </FacebookProvider>
      </GoogleOAuthProvider>
    </GoogleReCaptchaProvider>
  );
};

export default AuthRoutes;